<template>
    <div class="mr-10">
        <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
            {{ snackbar_message }}
        </v-snackbar>
        <div class="text-center" v-if="loader">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <v-container grid-list-md v-else>
            <div>
                <v-layout column class="mb-5">
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-row>
                                <v-col cols="12" md="2">
                                    <v-select v-model="search_domain" :items="domains" item-text="name" item-value="id"
                                        clearable solo label="Domaine" @change="reloadData($event)"></v-select>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-select v-model="search_department" :items="liste_dep" item-text="name"
                                        item-value="id" clearable solo label="Département"
                                        @change="reloadData($event)"></v-select>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-select v-model="search_municipality" :items="liste_municipalities"
                                        item-text="name" item-value="id" clearable solo label="Commune"
                                        @change="reloadData($event)"></v-select>
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field :value="startDateMoment" @click:clear="removeStartDate()"
                                                clearable label="De" readonly v-on="on" solo
                                                prepend-icon="mdi-calendar"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="start_date" @change="reloadData(1)">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-menu v-model="menu2" :close-on-content-click="false" max-width="290">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field :value="endDateMoment" @click:clear="removeEndDate()"
                                                clearable label="A" readonly v-on="on" solo
                                                prepend-icon="mdi-calendar"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="end_date" @change="reloadData(2)">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>

                            <v-select v-model="search_sae" :items="sae_list" item-text="name" item-value="id" clearable
                                solo label="SAE" @change="reloadData($event)" class="mr-2"></v-select>

                            <v-text-field v-model="search_word" @input="reloadData(0)" label="Filter par nom, type" solo
                                class="">
                            </v-text-field>
                        </v-layout>
                        <v-layout align-center justify-end fill-height>
                            <v-btn rounded color="primary" class="text-capitalize mr-2" :disabled="selected.length < 1"
                                @click="isDeletingEvent(selected)" v-if="$can('validate events')">
                                Supprimer
                                <v-icon right>mdi-check</v-icon>
                            </v-btn>
                            <v-btn rounded color="primary" class="text-capitalize mr-2" :disabled="selected.length < 1"
                                @click="validating(selected)" v-if="$can('validate events')">
                                Valider
                                <v-icon right>mdi-check</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </div>
            <div>
                <v-data-table v-if="events_coming" v-model="selected" :headers="headers" :items="events_coming"
                    :loading="loader" :mobile-breakpoint="600" show-select loading-text="Loading... Please wait"
                    :page.sync="currentPage" :server-items-length="eventTotalItems"
                    :items-per-page.sync="rowsPerPageItems" :footer-props="footerProps" class="mt-2">
                    <template v-slot:item.action="{ item }">
                        <v-icon small class="mr-2" @click="showEvent(item.id)" v-if="$can('view validate events')">
                            mdi-eye-outline
                        </v-icon>
                        <v-icon small class="mr-2" @click="editEvent(item.id)"
                            v-if="$can('edit events') || $can('edit events')">
                            mdi-pencil-outline
                        </v-icon>
                        <v-icon small @click="isDeletingEvent(item)"
                            v-if="$can('delete events') || $can('delete event')">
                            mdi-trash-can-outline
                        </v-icon>
                        <v-icon @click="validating(item)" v-if="
                            $can('validate events') &&
                            item.validate == false
                        ">
                            mdi-check
                        </v-icon>

                        <v-icon @click="noValidateItem(item)" v-if="
                            $can('validate events') &&
                            item.validate == false
                        ">
                            mdi-close
                        </v-icon>
                    </template>
                </v-data-table>
            </div>
        </v-container>

        <v-layout row justify-center>
            <v-dialog v-model="dialog_deletion" persistent hide-overlay max-width="550">
                <delete-with-password v-if="item" @cancel="dialog_deletion = false" @deleteItem="delEvent" :item="item"
                    message="Etes - vous sûr de vouloir supprimer cet évènement ?"
                    title="Suppression"></delete-with-password>
            </v-dialog>
        </v-layout>

        <v-layout row justify-center>
            <v-dialog v-model="dialog_no_validate" persistent hide-overlay max-width="550">
                <reject-event-validation v-if="item" @cancel="dialog_no_validate = false" @noValidateItem="noValidate"
                    :item="item" message="Etes - vous sûr de vouloir non valider cet évènement ?"
                    title="Non validation"></reject-event-validation>
            </v-dialog>
        </v-layout>

        <v-layout justify-center>
            <v-dialog v-model="dialog" persistent hide-overlay max-width="290">
                <v-card>
                    <v-card-title class="headline">{{
                        dialog_title
                        }}</v-card-title>
                    <v-card-text>{{ delete_message }}</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn rounded color="orange" @click="dialog = false">Non</v-btn>
                        <v-btn :loading="loading" :disabled="loading" rounded color="primary"
                            @click="validateItem()">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import axios from "axios";
import Permissions from "~/mixins/Permissions";
import DeleteWithPassword from "~/components/DeleteWithPassword";
import RejectEventValidation from "~/components/RejectEventValidation";

export default {
    name: "event-validate",
    components: {
        DeleteWithPassword,
        RejectEventValidation
    },
    mixins: [Permissions],
    data() {
        return {
            snackbar: false,
            snackbar_message: "",
            snackbar_timeout: 5000,
            snackbar_color: "",
            headers: [
                { text: "Nom", value: "name" },
                { text: "SAE", value: "sae_type.name" },
                { text: "Date debut", value: "event_date" },
                { text: "Domaine", value: "domain.name" },
                { text: "Commune", value: "municipality.name" },
                { text: "Ville/Village", value: "town.name" },
                { text: "Animateur", value: "users[0].profile.full_name" },
                { text: "Date d'ajout", value: "created_at" },
                { text: "Valid. niveau 1.", value: 'user_level_one.profile.full_name' },
                { text: "Valid. niveau 2.", value: 'user_level_two.profile.full_name' },
                { text: "Actions", value: "action", sortable: false }
            ],

            pagination: {
                current: 1,
                total: 0,
                rowsPerPage: 15
            },
            dialog_deletion: false,
            deletion_id: null,
            deletion_index: null,


            dialog_no_validate: false,
            no_validate_id: null,
            no_validate_index: null,

            search_domain: null,
            search_department: null,
            search_municipality: null,
            search_sae: null,
            search_word: null,
            start_date: null,
            end_date: null,
            menu1: false,
            menu2: false,
            search_ongoing: false,
            loader: false,
            new_event_added: false,
            event_deleted: false,
            event_updated: false,
            selected: [],
            event_closed: false,
            footerProps: {
                "items-per-page-options": [5, 10, 15, 30, 50, 100, 500],
                "items-per-page-text": "Lignes par page"
            },
            dialog_title: "",
            delete_message: "",
            loading: false,
            dialog: false,
            item: null,
            reason: null,
            ids: [],
            events_coming: [],
            eventTotalItems: 0,
            rowsPerPageItems: 15,
            currentPage: 1,
            sae_list: [],
            liste_municipalities: [],
            event_id: null,
            uri:
                "/api/events-no-validate?include=municipality,domain,district,town,chains,user_level_one,user_level_two,saeType"
        };
    },

    computed: {
        domains() {
            return this.$store.getters.getDomains;
        },
        startDateMoment() {
            return this.start_date
                ? this.$moment(this.start_date).format("D MMMM YYYY")
                : "";
        },

        endDateMoment() {
            return this.end_date
                ? this.$moment(this.end_date).format("D MMMM YYYY")
                : "";
        },

        liste_dep() {
            return this.$store.getters.departments;
        }
    },

    mounted() {
        this.new_event_added = this.$route.params.new_event_added;
        this.event_deleted = this.$route.params.event_deleted;
        this.event_updated = this.$route.params.event_updated;
        this.event_closed = this.$route.params.event_closed;
    },
    created() {
        this.event_id = this.$route.query.event_id
        this.$checkPermission("view validate events");
        this.fetchUtils();
        this.fetchSaes();
        this.fetchDomains();
        this.fetchDepartments();
        this.fetchMunicipalities();
    },
    watch: {
        rowsPerPageItems(newVal, oldVal) {
            if (newVal != oldVal) {
                this.pagination.rowsPerPage = newVal;
                this.fetchUtils();
            }
        },
        currentPage(newVal, oldVal) {
            if (newVal != oldVal) {
                this.pagination.current = newVal;
                this.fetchUtils();
            }
        }
    },
    methods: {
        async fetchUtils() {
            this.loader = true;
            this.uri =
                this.uri +
                "&page=" +
                this.pagination.current +
                "&size=" +
                this.pagination.rowsPerPage;
            if (this.event_id) {
                this.uri = this.uri + '&event_id=' + this.event_id
            }
            const results = (await axios.get(this.uri)).data;

            if (results.data) {
                this.events_coming = results.data;
                this.currentPage = results.current_page;
                this.eventTotalItems = results.total;
                this.rowsPerPageItems = parseInt(results.per_page);
            }

            this.loader = false;
        },
        async fetchSaes() {
            this.loader = true;
            try {
                this.sae_list = (await axios.get("/api/sae_types")).data;
            } catch (e) {
                console.log(e);
            }
        },
        showEvent(id) {
            this.$router.push({ name: "events.show", params: { Pid: id } });
        },
        async fetchDomains() {
            this.loader = true;
            await this.$store.dispatch("loadDomains").then(() => {
                this.loader = false;
            });
        },
        async fetchDepartments() {
            this.loader = true;
            await this.$store.dispatch("fetchDepartments").then(() => {
                this.loader = false;
            });
        },

        editEvent(id) {
            const payload = {};
            payload.event_id = id;
            payload.router = this.$router;

            this.$store.dispatch("loadEditableEvent", payload);
        },

        isDeletingEvent(item) {
            this.ids = [];
            this.deletion_id = null;
            if (Array.isArray(item) && item.length > 0) {
                this.ids = this.selected.map(item => {
                    return item.id;
                });
                this.item = "multiple";
                this.dialog_deletion = true;
            } else {
                this.item = item.name;
                this.deletion_id = item.id;
                this.dialog_deletion = true;
            }
        },
        noValidateItem(item) {
            this.item = item;
            this.dialog_no_validate = true
            this.no_validate_id = item.id
        },
        isNovalidatingEvent(item) {

        },
        validating(item) {
            this.ids = [];
            this.isValidate = true;
            if (Array.isArray(item) && item.length > 0) {
                this.ids = this.selected.map(item => {
                    return item.id;
                });
                this.dialog_title = "Validation";
                this.delete_message =
                    "Etes-vous sûr de vouloir valider ces évènements ?";
                this.dialog = true;
            } else {
                this.ids.push(item.id);
                this.isSingleDelete = true;
                this.dialog_title = "Validation";
                this.delete_message =
                    "Etes-vous sûr de vouloir valider cet évènement ?";
                this.dialog = true;
            }
        },
        async fetchMunicipalities() {
            this.loader = true;
            try {
                this.liste_municipalities = (await axios.get(
                    "/municipalities?include=department"
                )).data;
            } catch (e) {
                console.log(e);
            }
        },
        async validateItem() {
            this.loading = true;
            const uri =
                "/api/events-no-validate?page=" +
                this.pagination.current +
                "&size=" +
                this.pagination.rowsPerPage;
            await this.$store.dispatch("validateEvents", {
                ids: this.ids,
                uri
            });
            this.loading = false;
            this.dialog = false;
            this.snackbar = true;
            this.selected = [];
            this.ids = [];
            if (this.ids.length > 1) {
                this.snackbar_message = "Evènements validés avec succès!";
            } else {
                this.snackbar_message = "Evènement validé avec succès!";
            }
            this.fetchUtils();
        },
        async delEvent(payload) {
            this.reason = payload.reason;
            if (this.deletion_id) {

                axios.post("/api/send-event-delete-reason/" + this.deletion_id, {
                    reason: this.reason,
                    type: "Suppression"
                }).then(response => {
                    this.reason = ""
                    const uri = "/api/events/" + this.deletion_id;
                    const objet = this;
                    axios
                        .delete(uri)
                        .then(response => {
                            // objet.$forceUpdate();
                            objet.dialog_deletion = false;
                            objet.snackbar = true;
                            objet.snackbar_color = "success";
                            objet.snackbar_message = "Evènement supprimé !";

                            this.fetchUtils();
                        })
                        .catch(err => {
                            console.log("Event deletion error ", err);
                        });
                }).catch(err => {
                    console.log("Event deletion error ", err);
                })

                // const route_obj = this.$router

            } else if (this.ids.length > 0) {
                this.loading = true;

                await axios.post("/api/events/delete", { ids: this.ids });

                this.loading = false;
                this.dialog = false;
                this.snackbar = true;
                this.selected = [];
                this.ids = [];
                this.dialog_deletion = false;
                this.snackbar_color = "success";
                if (this.ids.length > 1) {
                    this.snackbar_message = "Evènements validés avec succès!";
                } else {
                    this.snackbar_message = "Evènement validé avec succès!";
                }
                this.fetchUtils();
            }
        },
        async noValidate(payload) {
            this.reason = payload.reason;

            axios.post("/api/send-event-delete-reason/" + this.no_validate_id, {
                reason: this.reason,
                type: "Rejet"
            }).then(response => {
                this.reason = ""
                const uri = "/api/events/" + this.deletion_id;
                const objet = this;
                objet.dialog_no_validate = false;
                objet.snackbar = true;
                objet.snackbar_color = "success";
                objet.snackbar_message = "Validation annulée !";

                this.fetchUtils();

            }).catch(err => {
                console.log("Event deletion error ", err);
            })

            this.no_validate_id
            this.dialog = false;
            this.dialog_no_validate = false;
            this.isNoValidating = true;
        },
        async reloadData(value) {
            this.loader = true;
            let uri =
                "/api/events-no-validate?include=municipality,domain,district,town,chains,user_level_one,user_level_two";

            if (this.start_date) {
                this.menu1 = false;

                uri = uri + "&start_date=" + this.start_date;
            }

            if (this.end_date) {
                this.menu2 = false;
                uri = uri + "&end_date=" + this.end_date;
            }
            if (this.search_word) {
                uri = uri + "&search=" + this.search_word;
            }
            if (this.search_domain) {
                uri = uri + "&filter[domain_id]=" + this.search_domain;
            }
            if (this.search_department) {
                uri = uri + "&filter[department_id]=" + this.search_department;
                this.liste_municipalities = (await axios.get(
                    "/municipalities?include=department&filter[department_id]=" +
                    this.search_department
                )).data;
            }

            if (this.search_municipality) {
                uri =
                    uri +
                    "&filter[municipality_id]=" +
                    this.search_municipality;
            }
            if (this.search_sae) {
                uri = uri + "&filter[sae_type_id]=" + this.search_sae;
            }
            this.uri = uri;

            this.fetchUtils();

            this.loader = false;
        },

        removeStartDate() {
            this.start_date = null;
            this.reloadData();
        },

        removeEndDate() {
            this.end_date = null;
            this.reloadData();
        }
    }
};
</script>

<style scoped>
.gris-couleur {
    background-color: #e0e0e0;
}

.white-couleur {
    color: white;
}

.v-card__title {
    font-size: 1.2rem;
    font-weight: 400;
    letter-spacing: normal;
    line-height: 1.5rem;
}

.titreEvent {
    text-decoration: none;
}

.titreEvent:hover {
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/events/index-validate.vue